import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from '../services/config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import { SharedService } from '.././services/shared.service';
import { CommonService } from '../services/common.services';
import { firstValueFrom, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PingAuthService {

  codeChallange = '';
  state = '';
  environment: any;
  accessToken: any;
  idToken: any;
  user: any;
  role: any;
  sessionTimer: any;

  constructor(
    public router: Router,
    private readonly config: ConfigService,
    private readonly http: HttpClient,
    private readonly shared: SharedService,
    private readonly commonService: CommonService
  ) {
    this.environment = this.config.getConfig();
  }  

 async verifyAccess(currentRoute: string, route: string): Promise<boolean> {
   try {
    debugger;
     const response: any = await firstValueFrom(
      this.commonService.authCall());
     const allowedRoutes: string[] = response?.access_list ?? [];
     const expSeconds: number = response?.exp;

    if (allowedRoutes.length === 0){
      alert("No Access");
      this.logout();
      return false;
    }
    
 if (expSeconds && expSeconds > 0) {
      this.startSessionTimer(expSeconds);
    }

    if ( allowedRoutes.includes(currentRoute)){
      return true;
    }
    
    alert("Access Denied");
    if( route){
      this.router.navigateByUrl(route);
    } else {
      this.router.navigate(['/']);
    }
    return false;

   } catch (err) {
     return false;
   }
}



 
startSessionTimer(expSeconds: number) {
  // Clear existing timer
  if (this.sessionTimer) {
    clearTimeout(this.sessionTimer);
  }

  const currentTime = Math.floor(Date.now() / 1000);
  const timeLeftSeconds = (expSeconds - currentTime)*1000;
  this.sessionTimer = setTimeout(() => {
    this.handleSessionExpiry();
  }, timeLeftSeconds);
}

handleSessionExpiry() {
  alert("Session expired. Please login again.");
  this.logout();
}


  public async login(): Promise<void> {
    debugger;
    if (sessionStorage.getItem('accessToken')) {
      await this.userProfile();
    }
    else if (!sessionStorage.getItem('code_challenge')) {
      this.showPingLogin();
    }
    else {
      await this.callPingLoginService();
    }
  }

  showPingLogin() {
    const initialUrl = window.location.href;
    sessionStorage.setItem('initialUrl', initialUrl);

    this.codeChallange = this.generateCodeChallengeAndState();
    this.state = this.generateCodeChallengeAndState();

    const objdata = {
      "client_id": 'xbxm_pr',
      "response_type": "code",
      "scope": "openid",
      'redirect_uri': window.location.origin,
      "code_challenge": this.codeChallange,
      "state": this.state
    }

    sessionStorage.setItem('code_challenge', this.codeChallange);
    sessionStorage.setItem('state', this.state);
    const url = `${this.environment.pingAuthURL}?${this.serializeData(objdata)}`;
    location.href = url;
  }

  callPingLoginService(): any {
    const authCodeVal = this.getParameterByName("code", window.location.href);
    const stateVal = this.getParameterByName("state", window.location.href);

    if (!stateVal || stateVal !== sessionStorage.getItem('state') || !authCodeVal
    ) {
      this.clearSession();
      this.showPingLogin();
      return false;
    }
    this.codeChallange = sessionStorage.getItem('code_challenge') || this.environment.revokeUrl;
    const obj = {
      "code": authCodeVal,
      "grant_type": "authorization_code",
      "client_id": 'xbxm_pr',
      "code_verifier": this.codeChallange,
      "redirect_uri": window.location.origin
    }
    return this.http
      .post(this.environment.pingTokenUrl,
        this.serializeData(obj),
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }).toPromise()
      .then((response: any) => {
        response = JSON.stringify(response);
        response = JSON.parse(response);
        this.accessToken = response['access_token'];
        this.idToken = response['id_token'];
        sessionStorage.setItem('accessToken', this.accessToken);
        this.userProfile();
        location.href = sessionStorage.getItem('initialUrl') ?? '/';
      },
        err => {
          alert('No Access');
          this.shared.hide();
          this.showPingLogin();
          // this.router.navigate(['no-access'], { skipLocationChange: true })
        });
  }

  public async userProfile(): Promise<any> {
    const token = sessionStorage.getItem('accessToken') || '';
    const options = {
      headers: new HttpHeaders().set('Authorization', 'Bearer ' + token)
    }
    this.http
      .get(this.environment.userInfoApi, options)
      .subscribe((response: any) => {
        this.user = response;
        const email = this.user.sub;
        sessionStorage.setItem('email', email);
         this.shared.setEmail(email);
      }, err => {
        this.clearSession();
        this.showPingLogin();
      });
  }

  generateCodeChallengeAndState() {
    let codeVerifier = '';
    codeVerifier = this.generateRandomString(128);
    return this.base64URL(CryptoJS.SHA256(codeVerifier))
  }

  generateRandomString(length: any): string {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    const randomValues = new Uint32Array(length);
    window.crypto.getRandomValues(randomValues);

    for (let i = 0; i < length; i++) {
      text += possible.charAt(randomValues[i] % possible.length);
    }
    return text;
  }

  base64URL(string: any) {

    return string.toString(CryptoJS.enc.Base64)
      .replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')

  }

  serializeData = function (obj: any) {
    const str = [];
    for (const p in obj) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    }
    return str.join("&");
  }


  public getParameterByName(name: string, url: string) {
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) { return null };
    if (!results[2]) { return '' };
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  logout() {
    this.idToken = sessionStorage.getItem('accessToken');
    const obj = {
      token: this.idToken,
      token_type_hint: 'access_token',
      client_id: 'xbxm_pr'
    };
    const options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
    };
    this.http.post(this.environment.revokeUrl, this.serializeData(obj), options)
      .subscribe(response => {
        const newTab = window.open(this.environment.microsoftLogOutUrl, 'microsoftLogout', 'width=600,height=600');
        const checkInterval = setInterval(() => {
          // if (newTab?.closed) {
            // clearInterval(checkInterval);
            this.pingLogout();
            this.clearSession();
        //   }
        }, 2000);
      })
  }

  public clearSession(): void {
    sessionStorage.clear();
    localStorage.clear();
  }

  pingLogout() {
    fetch(this.environment.logOutUrl, { method: "GET", credentials: "include" }).finally(() => {
      window.location.href = this.environment.logOutUrl;
    })
  }
}

